





























import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import GeneralProductSettingsEdit from '@/components/Products/Forms/Shared/GeneralProductSettingsEdit.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'GeneralProductSettingsEditDialog', components: { GeneralProductSettingsEdit } })
export default class extends SaascadaVueDialog {

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            ProductDetailsModule.prepareProductViewModel();
        }
    }

    async save() {
        if (!(this.$refs.form as any).validateForm()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.editGeneralSettings();
            await ProductDetailsModule.getHistory();
        }
    }

}
